import { ZtTableHeaderType } from '../zt-table/zt-table.model';

export interface ZtFilterConfig {
    key: string;
    type: ZtTableHeaderType;
    data?: string[];
    selected?: string;
}

export enum ZtFilterEventType {
    NO_MATCH,
    MATCH,
    ALL_MATCH,
}

export interface ZtFilterChangeEvent {
    type: ZtFilterEventType;
    data?: any;
}

export interface ZtFilterEvent {
    key: string;
    eventType: ZtFilterEventType;
    dataType: ZtTableHeaderType;
    data?: any;
}
